var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Klienci")]),_vm._m(0),_c('user-quick-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('table',{staticClass:"row-border hover order-column",staticStyle:{"width":"100%"},attrs:{"id":"usersTable","cellspacing":"0"}})])
}]

export { render, staticRenderFns }